import { RedirectRequest } from '@azure/msal-browser';

import { getMsalClient } from '../client';

export const authenticate = async (request?: RedirectRequest) => {
  await getMsalClient().loginRedirect(request);
};
